import ScrollReveal from '@/components/ScrollReveal';

const STATS = [
  { number: '10', label: 'Years in Business' },
  { number: '20K+', label: 'Landlords Served' },
  { number: '2', label: 'Cities: London & Manchester' },
  { number: '48h', label: 'Report Turnaround' },
];

export default function StatsSection() {
  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {STATS.map((stat, i) => (
            <ScrollReveal key={stat.label} delay={i * 0.1}>
              <div className="text-center lg:text-left">
                <p className="mono-number text-navy" style={{ fontSize: 'clamp(3rem, 6vw, 5rem)' }}>{stat.number}</p>
                <p className="caps-label text-muted-foreground mt-2">{stat.label}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}